import { bzAxios } from 'Lib/bzAxios'
import { TagsResponse } from 'Types/TagsResponse'
import { ExtractFnReturnType } from 'Lib/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { useQuery } from '@tanstack/react-query'

type QueryFnType = typeof getTags

const getTags = (networkId: string): Promise<TagsResponse | Error> => {
  return bzAxios
    .get<TagsResponse>(`/tags?networkIdEnc=${networkId}`)
    .then((res) => {
      return res.data
    })
    .catch((e: Error) => {
      return e
    })
}

export const useGetTags = () => {
  const networkId = useUserStore.getState().networkId
  const query = useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['tagsListPerNetworkId'],
    queryFn: () => getTags(networkId),
  })
  const data = !query.data || query.data instanceof Error ? [] : query.data
  return { ...query, data }
}
